import type { MaterialIconsProps } from "./types";

export function MaterialIcons({ icon, className, onClick, title }: MaterialIconsProps) {
    const Wrapper = onClick ? 'button' : 'span'
    return (
        <Wrapper 
            className={`material-symbols-outlined ${className}`} 
            onClick={onClick}
            title={title}
            type={onClick ? 'button' : undefined}
        >
            {icon}
        </Wrapper>
    )
}